import React from "react";
import block from "bem-cn-lite";
import * as icons from "./icons";

const b = block("RequestFormsControls");

export default ({ items = [], style }) => (
    <div className={b()} style={style} >
        {items.map((item, index) => {
            const Icon = icons[item.icon];
            return <div className={b("item", { chevron: item.chevron })} key={index}>
                <div className={b("icon")}>
                    <Icon />
                </div>
                {item.name && <div className={b("text")}>{item.name}</div>} 
            </div>
        })}
    </div>
);
